<template>
    <div class="pt-2">
        <div class="col-sm-12">
            <Transition name="fade">
                <mvr-inspectables-list :defaultInspectables="inspectables" @add="editMode = true"
                    @edit="onEditInspectable" />
            </Transition>
            <base-modal v-if="editMode" size="lg" :hide-header="true" :hide-footer="true" @close="clearEditState">
                <mvr-inspectable-editor :editInspectable="inspectable" @closeAndUpdate="updateInspectables" @close="clearEditState" />
            </base-modal>
            <div v-if="loading" id="loader" class="spinner" />
        </div>
    </div>
</template>

<script>
import { restApi } from '@/components/mixins/RestApiMixin'
import MvrInspectablesList from '@/components/inspections/mvrInspections/MvrInspectablesList'
import MvrInspectableEditor from '@/components/inspections/mvrInspections/MvrInspectableEditor'
import BaseModal from "@/components/BaseModal";

export default {
    name: 'MvrInspectablesView',
    components: {
        BaseModal,
        MvrInspectablesList,
        MvrInspectableEditor
    },
    mixins: [restApi],
    data: function () {
        return {
            inspectables: [],
            inspectable: null,
            editMode: false,
            loading: true
        }
    },
    mounted: function () {
        this.fetchInspectables()
    },
    methods: {
        fetchInspectables() {
            this.inspectables = []
            this.loading = true
            this.restFetch(this.mvrInspectableUrl, (response) => {
                this.inspectables = response.data
                this.loading = false
            })
        },
        updateInspectables() {
            this.clearEditState()
            this.fetchInspectables()
        },
        onEditInspectable(inspectable) {
            this.editMode = true
            this.inspectable = inspectable
        },
        clearEditState() {
            this.editMode = false
            this.inspectable = null
        }
    }
}
</script>
